import { ProcedureSpecificationMaterialRulesConfig } from '@core/procedure-helpers/models/specification-material-rules-config';
import { rulesForFixedRestorativeGlidewellIo } from './specification-material-rules/fixed-restorative-glidewell-io';
import { rulesForFixedRestorative } from './specification-material-rules/fixed-restorative';

export const procedureSpecificationMaterialRules: ProcedureSpecificationMaterialRulesConfig = {
	ProcedureRules: [rulesForFixedRestorativeGlidewellIo, rulesForFixedRestorative]
};
